import { palette } from "../utils.js";

export const COLORS = {
  "Color.Primary.100": {
    defaultValue: "#eef5ff",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[0];
    }
  },
  "Color.Primary.200": {
    defaultValue: "#deeaff",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[1];
    }
  },
  "Color.Primary.300": {
    defaultValue: "#acccff",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[2];
    }
  },
  "Color.Primary.400": {
    defaultValue: "#69a3ff",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[3];
    }
  },
  "Color.Primary.500": {
    defaultValue: "#0565ff",
    value: "#0565ff",
    referredIn: [
      "Color.Primary.100",
      "Color.Primary.200",
      "Color.Primary.300",
      "Color.Primary.400",
      "Color.Primary.600",
      "Color.Primary.700",
      "Color.Primary.800",
      "Color.Text.Blue"
    ]
  },
  "Color.Primary.600": {
    defaultValue: "#003c9c",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[5];
    }
  },
  "Color.Primary.700": {
    defaultValue: "#002157",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[6];
    }
  },
  "Color.Primary.800": {
    defaultValue: "#000711",
    valueFunc: (meta) => {
      return palette(meta["Color.Primary.500"].value)[7];
    }
  },
  "Color.Secondary.One.100": {
    defaultValue: "#f2f9f2",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[0];
    }
  },
  "Color.Secondary.One.200": {
    defaultValue: "#d9eed8",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[1];
    }
  },
  "Color.Secondary.One.300": {
    defaultValue: "#c0e3bf",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[2];
    }
  },
  "Color.Secondary.One.400": {
    defaultValue: "#8dcc8b",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[3];
    }
  },
  "Color.Secondary.One.500": {
    defaultValue: "#4aa147",
    value: "#4aa147",
    referredIn: [
      "Color.Secondary.One.100",
      "Color.Secondary.One.200",
      "Color.Secondary.One.300",
      "Color.Secondary.One.400",
      "Color.Secondary.One.600",
      "Color.Secondary.One.700",
      "Color.Secondary.One.800"
    ]
  },
  "Color.Secondary.One.600": {
    defaultValue: "#2c612b",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[5];
    }
  },
  "Color.Secondary.One.700": {
    defaultValue: "#193618",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[6];
    }
  },
  "Color.Secondary.One.800": {
    defaultValue: "#050b05",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.One.500"].value)[7];
    }
  },
  "Color.Secondary.Two.100": {
    defaultValue: "#fcf2f9",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[0];
    }
  },
  "Color.Secondary.Two.200": {
    defaultValue: "#f6d9ed",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[1];
    }
  },
  "Color.Secondary.Two.300": {
    defaultValue: "#f0c0e1",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[2];
    }
  },
  "Color.Secondary.Two.400": {
    defaultValue: "#e58dc9",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[3];
    }
  },
  "Color.Secondary.Two.500": {
    defaultValue: "#d341a5",
    value: "#d341a5",
    referredIn: [
      "Color.Secondary.Two.100",
      "Color.Secondary.Two.200",
      "Color.Secondary.Two.300",
      "Color.Secondary.Two.400",
      "Color.Secondary.Two.600",
      "Color.Secondary.Two.700",
      "Color.Secondary.Two.800"
    ]
  },
  "Color.Secondary.Two.600": {
    defaultValue: "#861f66",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[5];
    }
  },
  "Color.Secondary.Two.700": {
    defaultValue: "#4b1139",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[6];
    }
  },
  "Color.Secondary.Two.800": {
    defaultValue: "#0f030b",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Two.500"].value)[7];
    }
  },
  "Color.Secondary.Three.100": {
    defaultValue: "#fefaee",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[0];
    }
  },
  "Color.Secondary.Three.200": {
    defaultValue: "#fdf0cc",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[1];
    }
  },
  "Color.Secondary.Three.300": {
    defaultValue: "#fce7ab",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[2];
    }
  },
  "Color.Secondary.Three.400": {
    defaultValue: "#f9d367",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[3];
    }
  },
  "Color.Secondary.Three.500": {
    defaultValue: "#eeb209",
    value: "#eeb209",
    referredIn: [
      "Color.Secondary.Three.100",
      "Color.Secondary.Three.200",
      "Color.Secondary.Three.300",
      "Color.Secondary.Three.400",
      "Color.Secondary.Three.600",
      "Color.Secondary.Three.700",
      "Color.Secondary.Three.800"
    ]
  },
  "Color.Secondary.Three.600": {
    defaultValue: "#8f6b05",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[5];
    }
  },
  "Color.Secondary.Three.700": {
    defaultValue: "#4f3b03",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[6];
    }
  },
  "Color.Secondary.Three.800": {
    defaultValue: "#100c01",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Three.500"].value)[7];
    }
  },
  "Color.Secondary.Four.100": {
    defaultValue: "#fdf3f2",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[0];
    }
  },
  "Color.Secondary.Four.200": {
    defaultValue: "#f9dad9",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[1];
    }
  },
  "Color.Secondary.Four.300": {
    defaultValue: "#f4c1bf",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[2];
    }
  },
  "Color.Secondary.Four.400": {
    defaultValue: "#ec8f8c",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[3];
    }
  },
  "Color.Secondary.Four.500": {
    defaultValue: "#df4440",
    value: "#df4440",
    referredIn: [
      "Color.Secondary.Four.100",
      "Color.Secondary.Four.200",
      "Color.Secondary.Four.300",
      "Color.Secondary.Four.400",
      "Color.Secondary.Four.600",
      "Color.Secondary.Four.700",
      "Color.Secondary.Four.800"
    ]
  },
  "Color.Secondary.Four.600": {
    defaultValue: "#931c19",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[5];
    }
  },
  "Color.Secondary.Four.700": {
    defaultValue: "#520f0e",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[6];
    }
  },
  "Color.Secondary.Four.800": {
    defaultValue: "#100303",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Four.500"].value)[7];
    }
  },
  "Color.Secondary.Five.100": {
    defaultValue: "#fef7f0",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[0];
    }
  },
  "Color.Secondary.Five.200": {
    defaultValue: "#fde6d2",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[1];
    }
  },
  "Color.Secondary.Five.300": {
    defaultValue: "#fcd5b5",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[2];
    }
  },
  "Color.Secondary.Five.400": {
    defaultValue: "#f9b479",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[3];
    }
  },
  "Color.Secondary.Five.500": {
    defaultValue: "#f58220",
    value: "#f58220",
    referredIn: [
      "Color.Secondary.Five.100",
      "Color.Secondary.Five.200",
      "Color.Secondary.Five.300",
      "Color.Secondary.Five.400",
      "Color.Secondary.Five.600",
      "Color.Secondary.Five.700",
      "Color.Secondary.Five.800"
    ]
  },
  "Color.Secondary.Five.600": {
    defaultValue: "#9f4d07",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[5];
    }
  },
  "Color.Secondary.Five.700": {
    defaultValue: "#582b04",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[6];
    }
  },
  "Color.Secondary.Five.800": {
    defaultValue: "#120901",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Five.500"].value)[7];
    }
  },
  "Color.Secondary.Six.100": {
    defaultValue: "#f5f5fd",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[0];
    }
  },
  "Color.Secondary.Six.200": {
    defaultValue: "#e2e2f8",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[1];
    }
  },
  "Color.Secondary.Six.300": {
    defaultValue: "#cfcff3",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[2];
    }
  },
  "Color.Secondary.Six.400": {
    defaultValue: "#a8a8e9",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[3];
    }
  },
  "Color.Secondary.Six.500": {
    defaultValue: "#6e6edb",
    value: "#6e6edb",
    referredIn: [
      "Color.Secondary.Six.100",
      "Color.Secondary.Six.200",
      "Color.Secondary.Six.300",
      "Color.Secondary.Six.400",
      "Color.Secondary.Six.600",
      "Color.Secondary.Six.700",
      "Color.Secondary.Six.800"
    ]
  },
  "Color.Secondary.Six.600": {
    defaultValue: "#27279e",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[5];
    }
  },
  "Color.Secondary.Six.700": {
    defaultValue: "#161658",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[6];
    }
  },
  "Color.Secondary.Six.800": {
    defaultValue: "#040412",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Six.500"].value)[7];
    }
  },
  "Color.Secondary.Seven.100": {
    defaultValue: "#ecfdff",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[0];
    }
  },
  "Color.Secondary.Seven.200": {
    defaultValue: "#c5fafe",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[1];
    }
  },
  "Color.Secondary.Seven.300": {
    defaultValue: "#9ef7fd",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[2];
    }
  },
  "Color.Secondary.Seven.400": {
    defaultValue: "#50f0fb",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[3];
    }
  },
  "Color.Secondary.Seven.500": {
    defaultValue: "#05c2cf",
    value: "#05c2cf",
    referredIn: [
      "Color.Secondary.Seven.100",
      "Color.Secondary.Seven.200",
      "Color.Secondary.Seven.300",
      "Color.Secondary.Seven.400",
      "Color.Secondary.Seven.600",
      "Color.Secondary.Seven.700",
      "Color.Secondary.Seven.800"
    ]
  },
  "Color.Secondary.Seven.600": {
    defaultValue: "#03747c",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[5];
    }
  },
  "Color.Secondary.Seven.700": {
    defaultValue: "#024145",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[6];
    }
  },
  "Color.Secondary.Seven.800": {
    defaultValue: "#000d0e",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Seven.500"].value)[7];
    }
  },
  "Color.Secondary.Eight.100": {
    defaultValue: "#eefafe",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[0];
    }
  },
  "Color.Secondary.Eight.200": {
    defaultValue: "#cbefff",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[1];
    }
  },
  "Color.Secondary.Eight.300": {
    defaultValue: "#a8e5ff",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[2];
    }
  },
  "Color.Secondary.Eight.400": {
    defaultValue: "#63d0fd",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[3];
    }
  },
  "Color.Secondary.Eight.500": {
    defaultValue: "#03adf3",
    value: "#03adf3",
    referredIn: [
      "Color.Secondary.Eight.100",
      "Color.Secondary.Eight.200",
      "Color.Secondary.Eight.300",
      "Color.Secondary.Eight.400",
      "Color.Secondary.Eight.600",
      "Color.Secondary.Eight.700",
      "Color.Secondary.Eight.800"
    ]
  },
  "Color.Secondary.Eight.600": {
    defaultValue: "#026892",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[5];
    }
  },
  "Color.Secondary.Eight.700": {
    defaultValue: "#013a51",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[6];
    }
  },
  "Color.Secondary.Eight.800": {
    defaultValue: "#000c10",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Eight.500"].value)[7];
    }
  },
  "Color.Secondary.Nine.100": {
    defaultValue: "#fff4f5",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[0];
    }
  },
  "Color.Secondary.Nine.200": {
    defaultValue: "#ffdfde",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[1];
    }
  },
  "Color.Secondary.Nine.300": {
    defaultValue: "#ffcacb",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[2];
    }
  },
  "Color.Secondary.Nine.400": {
    defaultValue: "#ffa0a0",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[3];
    }
  },
  "Color.Secondary.Nine.500": {
    defaultValue: "#ff6060",
    value: "#ff6060",
    referredIn: [
      "Color.Secondary.Nine.100",
      "Color.Secondary.Nine.200",
      "Color.Secondary.Nine.300",
      "Color.Secondary.Nine.400",
      "Color.Secondary.Nine.600",
      "Color.Secondary.Nine.700",
      "Color.Secondary.Nine.800"
    ]
  },
  "Color.Secondary.Nine.600": {
    defaultValue: "#d30000",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[5];
    }
  },
  "Color.Secondary.Nine.700": {
    defaultValue: "#750000",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[6];
    }
  },
  "Color.Secondary.Nine.800": {
    defaultValue: "#170000",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Nine.500"].value)[7];
    }
  },
  "Color.Secondary.Ten.100": {
    defaultValue: "#fff5ec",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[0];
    }
  },
  "Color.Secondary.Ten.200": {
    defaultValue: "#fee0c3",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[1];
    }
  },
  "Color.Secondary.Ten.300": {
    defaultValue: "#fecc9d",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[2];
    }
  },
  "Color.Secondary.Ten.400": {
    defaultValue: "#fca34d",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[3];
    }
  },
  "Color.Secondary.Ten.500": {
    defaultValue: "#ce6603",
    value: "#ce6603",
    referredIn: [
      "Color.Secondary.Ten.100",
      "Color.Secondary.Ten.200",
      "Color.Secondary.Ten.300",
      "Color.Secondary.Ten.400",
      "Color.Secondary.Ten.600",
      "Color.Secondary.Ten.700",
      "Color.Secondary.Ten.800"
    ]
  },
  "Color.Secondary.Ten.600": {
    defaultValue: "#7c3d02",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[5];
    }
  },
  "Color.Secondary.Ten.700": {
    defaultValue: "#452201",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[6];
    }
  },
  "Color.Secondary.Ten.800": {
    defaultValue: "#0e0700",
    valueFunc: (meta) => {
      return palette(meta["Color.Secondary.Ten.500"].value)[7];
    }
  },
  "Color.Success.100": {
    defaultValue: "#f2f9f2",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[0];
    }
  },
  "Color.Success.200": {
    defaultValue: "#d9eed8",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[1];
    }
  },
  "Color.Success.300": {
    defaultValue: "#c0e3bf",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[2];
    }
  },
  "Color.Success.400": {
    defaultValue: "#8dcc8b",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[3];
    }
  },
  "Color.Success.500": {
    defaultValue: "#4aa147",
    value: "#4aa147",
    referredIn: [
      "Color.Success.100",
      "Color.Success.200",
      "Color.Success.300",
      "Color.Success.400",
      "Color.Success.600",
      "Color.Success.700",
      "Color.Success.800"
    ]
  },
  "Color.Success.600": {
    defaultValue: "#2c612b",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[5];
    }
  },
  "Color.Success.700": {
    defaultValue: "#193618",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[6];
    }
  },
  "Color.Success.800": {
    defaultValue: "#050b05",
    valueFunc: (meta) => {
      return palette(meta["Color.Success.500"].value)[7];
    }
  },
  "Color.Error.100": {
    defaultValue: "#fdf3f2",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[0];
    }
  },
  "Color.Error.200": {
    defaultValue: "#f9dad9",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[1];
    }
  },
  "Color.Error.300": {
    defaultValue: "#f4c1bf",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[2];
    }
  },
  "Color.Error.400": {
    defaultValue: "#ec8f8c",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[3];
    }
  },
  "Color.Error.500": {
    defaultValue: "#df4440",
    value: "#df4440",
    referredIn: [
      "Color.Error.100",
      "Color.Error.200",
      "Color.Error.300",
      "Color.Error.400",
      "Color.Error.600",
      "Color.Error.700",
      "Color.Error.800"
    ]
  },
  "Color.Error.600": {
    defaultValue: "#931c19",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[5];
    }
  },
  "Color.Error.700": {
    defaultValue: "#520f0e",
    valueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[6];
    }
  },
  "Color.Error.800": {
    defaultValue: "#100303",
    rvalueFunc: (meta) => {
      return palette(meta["Color.Error.500"].value)[7];
    }
  },
  "Color.Warning.100": {
    defaultValue: "#fefaee",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[0];
    }
  },
  "Color.Warning.200": {
    defaultValue: "#fdf0cc",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[1];
    }
  },
  "Color.Warning.300": {
    defaultValue: "#fce7ab",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[2];
    }
  },
  "Color.Warning.400": {
    defaultValue: "#f9d367",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[3];
    }
  },
  "Color.Warning.500": {
    defaultValue: "#eeb209",
    value: "#eeb209",
    referredIn: [
      "Color.Warning.100",
      "Color.Warning.200",
      "Color.Warning.300",
      "Color.Warning.400",
      "Color.Warning.600",
      "Color.Warning.700",
      "Color.Warning.800"
    ]
  },
  "Color.Warning.600": {
    defaultValue: "#8f6b05",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[5];
    }
  },
  "Color.Warning.700": {
    defaultValue: "#4f3b03",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[6];
    }
  },
  "Color.Warning.800": {
    defaultValue: "#100c01",
    valueFunc: (meta) => {
      return palette(meta["Color.Warning.500"].value)[7];
    }
  },
  "Color.Info.100": {
    defaultValue: "#eef5ff",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[0];
    }
  },
  "Color.Info.200": {
    defaultValue: "#deeaff",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[1];
    }
  },
  "Color.Info.300": {
    defaultValue: "#acccff",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[2];
    }
  },
  "Color.Info.400": {
    defaultValue: "#69a3ff",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[3];
    }
  },
  "Color.Info.500": {
    defaultValue: "#0565ff",
    value: "#0565ff",
    referredIn: [
      "Color.Info.100",
      "Color.Info.200",
      "Color.Info.300",
      "Color.Info.400",
      "Color.Info.600",
      "Color.Info.700",
      "Color.Info.800"
    ]
  },
  "Color.Info.600": {
    defaultValue: "#003c9c",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[5];
    }
  },
  "Color.Info.700": {
    defaultValue: "#002157",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[6];
    }
  },
  "Color.Info.800": {
    defaultValue: "#000711",
    valueFunc: (meta) => {
      return palette(meta["Color.Info.500"].value)[7];
    }
  },
  "Color.Gray.100": {
    defaultValue: "#f7f7f8",
    value: "#f7f7f8"
  },
  "Color.Gray.200": {
    defaultValue: "#e7e8eb",
    value: "#e7e8eb"
  },
  "Color.Gray.300": {
    defaultValue: "#cfd2d7",
    value: "#cfd2d7"
  },
  "Color.Gray.400": {
    defaultValue: "#afb4bc",
    value: "#afb4bc"
  },
  "Color.Gray.500": {
    defaultValue: "#979da8",
    value: "#979da8"
  },
  "Color.Gray.600": {
    defaultValue: "#7f8693",
    value: "#7f8693"
  },
  "Color.Gray.700": {
    defaultValue: "#5c636e",
    value: "#5c636e"
  },
  "Color.Gray.800": {
    defaultValue: "#3f444c",
    value: "#3f444c"
  },
  "Color.Gray.900": {
    defaultValue: "#2e3137",
    value: "#2e3137"
  },
  "Color.Gray.999": {
    defaultValue: "#17191c",
    value: "#17191c"
  },
  "Color.White": {
    defaultValue: "#ffffff"
  },
  "Color.Transparent": {
    defaultValue: "#ffffff00"
  },
  "Color.White.Inverse": {
    defaultValue: "#ffffff"
  },
  "Color.Black": {
    defaultValue: "#000000"
  },
  "Color.White.Alpha.75": {
    defaultValue: "rgba(255, 255, 255, 0.75)"
  },
  "Color.White.Alpha.50": {
    defaultValue: "rgba(255, 255, 255, 0.5)"
  },
  "Color.White.Alpha.25": {
    defaultValue: "rgba(255, 255, 255, 0.25)"
  },
  "Color.White.Alpha.20": {
    defaultValue: "rgba(255, 255, 255, 0.2)"
  },
  "Color.White.Alpha.10": {
    defaultValue: "rgba(255, 255, 255, 0.1)"
  },
  "Color.Gray.Alpha.25": {
    defaultValue: "rgba(166, 182, 204, 0.25)"
  },
  "Color.Gray.Alpha.50": {
    defaultValue: "rgba(166, 182, 204, 0.5)"
  },
  "Color.Gray.Alpha.75": {
    defaultValue: "rgba(166, 182, 204, 0.75)"
  },
  "Color.Bg.White": {
    ref: "Color.White"
  },
  "Color.Bg.Gray": {
    ref: "Color.Gray.100"
  },
  "Color.Bg.Black": {
    defaultValue: "#080e19"
  },
  "Color.Overlay.Gray": {
    defaultValue: "rgba(23, 25, 28, 0.8)"
  },
  "Color.Overlay.Gray.50": {
    defaultValue: "rgba(23, 25, 28, 0.5)"
  },
  "Color.Overlay.Gray.75": {
    defaultValue: "rgba(23, 25, 28, 0.75)"
  },
  "Color.Text.Blue": {
    ref: "Color.Primary.500"
  },
  "Color.Link": {
    ref: "Color.Primary.500"
  },
  "Color.Shadow": {
    defaultValue: "rgba(41, 43, 47, 0.16)"
  }
};
